import { cn } from "@/lib/utils";
import { TagType } from "@/types/mapping";
import { FileText, Frame } from "lucide-react";
import { AxisIcon, LineItemIcon } from "../icons";

export const DimensionIcon = ({
  tagType,
  isSum,
  isExtendedTag,
  isDisabled = false,
}: {
  tagType: TagType;
  isSum: boolean;
  isExtendedTag: boolean;
  isDisabled?: boolean;
}) => {
  switch (tagType) {
    case "LINE_ITEM":
      return (
        <LineItemIcon
          className={cn(
            "w-[32px] h-[32px] text-[#0A0A0A] p-[8px] flex items-center flex-shrink-0 bg-blue-100 rounded-[8px]",
            isSum && "bg-orange-100 border border-orange-200 text-orange-600",
            isDisabled && "bg-blue-50 text-neutral-400",
          )}
          isExtendedTag={isExtendedTag}
        />
      );
    case "MEMBER":
      return (
        <AxisIcon
          className={cn(
            "w-[32px] h-[32px] text-[black] p-[8px] flex items-center flex-shrink-0 bg-blue-100 rounded-[8px]",
            isSum && "bg-blue-500",
          )}
          isExtendedTag={isExtendedTag}
        />
      );
    case "ABSTRACT":
      return (
        <Frame
          className={cn(
            "w-[32px] h-[32px] text-[white] p-[8px] flex items-center flex-shrink-0 bg-blue-500 rounded-[8px] ",
            isSum && "bg-blue-500",
          )}
        />
      );
    case "TEXTBLOCK":
      return (
        <FileText
          className={cn(
            "w-[32px] h-[32px] text-[#0A0A0A] p-[8px] flex items-center flex-shrink-0 bg-green-100 rounded-[8px]",
            isSum && "bg-green-200",
          )}
        />
      );
  }
};
